<div class="full-view flex-centered boxWrapper">
  <img class="cloud leftToRight" src="./assets/img/wolke_4.png" alt="" />
  <img class="cloud rightToLeft" src="./assets/img/wolke_4.png" alt="" />

  <div class="centered-box">
    <img class="logo" alt="Logos der Markant Start-up Arena" src="./assets/svg/Voila_Logo_RGB_2022_positiv.svg" />
    <a [routerLink]="isIE() ? null : loginRoute" class="button" [class.disabled]="isIE()"> Zum Login </a>
  </div>
</div>
